import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import ContentAdd from '@material-ui/icons/Add';

type Props = {
  fields: any,
  label: string,
  onClick?: any
};

class CreateItem extends Component<Props> {
  render() {
    const onClick = this.props.onClick ? this.props.onClick : () => this.props.fields.push({});

    return (
      <Button onClick={onClick} color="primary" className="button"><ContentAdd /> {this.props.label}</Button>
    );
  }
}

export default CreateItem;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/CreateItem.tsx